<script setup lang="ts">
import { useRouter } from 'vue-router';
import { OAuthRedirect } from '../method/OAuth';
import { onMounted, ref } from 'vue';

let router = useRouter();
let path=router.currentRoute.value.query.state?.toString();
let code = router.currentRoute.value.query.code;
let newPath="";
let location=ref("");
OAuthRedirect();//把#号转换到正确的位置
onMounted(()=>{
  console.log(path);
  console.log(code);
  location.value=window.location.href;
  //对路径进行导航处理，不能直接将路径作为参数，vue会直接重定向
  if(path!=null&&path!=""){
      let pathS=path?.split("/");
      switch((pathS[1]).toLowerCase()){
        case "bind":
          newPath="?code="+code+"&mobile="+pathS[2];
          router.push("/bind/"+newPath);
          break;
      }
  }else{
    router.push("/Login");
  }
})
</script>
<template>
  <img src="/src/assets/ymkj.png">
  <h1>获取信息中..</h1>
</template>
<style>
</style>